const nonDigitAndPeriod = /([^\d.]+)/g;
const precision = 0;

/**
 * Returns a string representation
 *
 * @param value
 * @returns {string}
 */
function stringify(value) {
  return value ? value.toString() : '';
}

/**
 * Removes extra periods from a string excluding the first
 * i.e 1..234.5..6 >>> 1.23456
 *
 * @param value
 * @returns {string}
 */
function removeExtraPeriods(value) {
  let arr = value.split('.');
  arr = arr.filter(a => a !== '');
  const integer = arr[0];
  const decimal = arr.slice(1).join('');
  return `${integer}.${decimal}`;
}

/**
 * Formats a string as a decimal number
 * Removes all non digits except first instance of a period
 * i.e. 1,23abc45{67.89.} >>> 1234567.89
 *
 * @param value
 * @returns {string}
 */
function decimalNumber(value) {
  let val = stringify(value);
  // remove all characters except digits [0-9] and periods [.]
  val = val.toString().replace(nonDigitAndPeriod, '');
  // remove all periods except first period
  if (val.includes('.')) {
    val = removeExtraPeriods(val);
  }
  return val;
}

/**
 * Removes the thousand separators from a numeric string
 *
 * @param value
 * @returns {string}
 */
function unformat(value) {
  return decimalNumber(value);
}

/**
 * Formats a numeric string and adds thousand separators
 *
 * @param value
 * @returns {string}
 */
function format(value) {
  const val = unformat(value);
  if (val.includes('.')) {
    const values = val.split('.');
    let integer = values[0];
    const decimal = values[1];
    integer = integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1,');
    return `${integer}.${decimal}`;
  }
  return val.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1,');
}

/**
 * Formats a numeric string with thousand separators to fixed precision
 *
 * @param value
 * @returns {string}
 */
function formatToFixed(value) {
  let val = stringify(value);
  if (val.endsWith('.')) {
    val = val.replace('.', '');
  }
  const fixed = parseFloat(unformat(val))
    .toFixed(precision)
    .toString();
  return format(fixed);
}

/**
 * Removes thousand separators, and converts to float with fixed precision
 * to pass back to the parent component
 *
 * @param value
 * @returns {string}
 */
function unformatToFixed(value) {
  return parseFloat(unformat(value)).toFixed(precision);
}

export { format, formatToFixed, unformatToFixed };
